import React, { useState, useEffect } from 'react';
import { db } from './firebase';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import styles from './Dashboard.module.css';

const Dashboard = () => {
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [copied, setCopied] = useState('');

  useEffect(() => {
    const fetchSubscribers = async () => {
      try {
        const q = query(collection(db, 'gmail-oomfs'), orderBy('timestamp', 'desc'));
        const querySnapshot = await getDocs(q);
        const subs = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        setSubscribers(subs);
      } catch (err) {
        console.error('Error fetching subscribers:', err);
        setError('failed to load subscribers');
      } finally {
        setLoading(false);
      }
    };

    fetchSubscribers();
  }, []);

  const copyEmails = (format) => {
    if (subscribers.length === 0) return;

    let text = '';
    if (format === 'comma') {
      text = subscribers.map(s => s.email).join(', ');
    } else if (format === 'newline') {
      text = subscribers.map(s => s.email).join('\n');
    } else if (format === 'csv') {
      text = 'email,twitter\n' + subscribers.map(s => `${s.email},${s.twitter || ''}`).join('\n');
    }

    navigator.clipboard.writeText(text);
    setCopied(format);
    setTimeout(() => setCopied(''), 2000);
  };

  return (
    <div className={styles.dashboardContainer}>
      <div className={styles.dashboardBox}>
        <header className={styles.header}>
          <h1>goomf subscribers</h1>
          <p className={styles.subtitle}>{subscribers.length} people</p>
        </header>

        <div className={styles.content}>
          {/* Subscribers List - Full Width */}
          <div className={`${styles.section} ${styles.fullWidth}`}>
            <div className={styles.subscriberHeader}>
              <h2>all subscribers ({subscribers.length})</h2>
              <div className={styles.copyButtons}>
                <button
                  onClick={() => copyEmails('comma')}
                  className={styles.copyBtn}
                  title="Copy as comma-separated"
                >
                  {copied === 'comma' ? '✓ copied' : 'copy all'}
                </button>
                <button
                  onClick={() => copyEmails('newline')}
                  className={styles.copyBtn}
                  title="Copy as newline-separated"
                >
                  {copied === 'newline' ? '✓ copied' : 'copy lines'}
                </button>
                <button
                  onClick={() => copyEmails('csv')}
                  className={styles.copyBtn}
                  title="Copy as CSV"
                >
                  {copied === 'csv' ? '✓ copied' : 'copy csv'}
                </button>
              </div>
            </div>

            {loading ? (
              <p className={styles.loading}>loading...</p>
            ) : error ? (
              <p className={styles.error}>{error}</p>
            ) : subscribers.length === 0 ? (
              <p className={styles.empty}>no subscribers yet</p>
            ) : (
              <div className={styles.subscribersTable}>
                <table>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>email</th>
                      <th>twitter</th>
                    </tr>
                  </thead>
                  <tbody>
                    {subscribers.map((sub, idx) => (
                      <tr key={sub.id}>
                        <td className={styles.index}>{idx + 1}</td>
                        <td className={styles.tableEmail}>{sub.email}</td>
                        <td className={styles.tableTwitter}>
                          {sub.twitter ? (
                            <a href={`https://twitter.com/${sub.twitter.replace('@', '')}`} target="_blank" rel="noopener noreferrer">
                              {sub.twitter}
                            </a>
                          ) : (
                            <span className={styles.noTwitter}>—</span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>

        <footer className={styles.footer}>
          <p>→ back to <a href="/goomf">signup</a> | <a href="/">portfolio</a></p>
        </footer>
      </div>
    </div>
  );
};

export default Dashboard;
